require('./dealer.tag');

riot.tag2('dealer-results-container', '<div class="dealer-results {\'has-results\': opts.dealers.length > 1}"> <div class="dealer-results-container"> <dealer each="{dealer, index in dealers}" index="{index}"></div> </dealer> <div class="dealers-result-more-button-container"> <span class="acr-cta-btn is-red-bg" onclick="{showMore}" if="{opts.dealers.length > maxSlice}" data-tracking="{trackingDataMoreDealers}">{labels.moreDealers}</span> </div> </div>', '', '', function(opts) {
    var mapConstants = require('../../core/constants.js').map;
    var trackingJSON = require('../../data/tracking-data');
    var self = this;
    var chunk = 0;

    self.trackingDataMoreDealers = JSON.stringify(trackingJSON.moreDealers);
    self.maxDealers = self.opts.isEmbeddedInRaq ? 3 : parseInt(self.opts.delta, 10) || 5;

    self.mixin('bus');

    self.maxSlice = (chunk * self.maxDealers) + self.maxDealers;

    function showMore() {
      var currentDealers;
      chunk++;

      self.maxSlice = (chunk * self.maxDealers) + self.maxDealers;
      currentDealers = self.opts.dealers.slice(0, self.maxSlice);

      self.update();
      self.bus.trigger(self.bus.EVENTS.MAP.RESIZE);
      self.bus.trigger(self.bus.EVENTS.DEALERS.DATA_LOADED, {
        points: currentDealers,
        total: currentDealers.length,
      });
    }

    function reset() {
      chunk = 0;

      self.maxSlice = (chunk * self.maxDealers) + self.maxDealers;
    }

    self.on('mount', function mountself() {
      self.dealers = self.opts.dealers.slice(0, self.maxDealers);

      self.update();
    });

    self.on('update', function onUpdate() {
      self.dealers = self.opts.dealers.slice(0, self.maxSlice);
    });

    function setPreferred() {
      self.root.children[0].children[1].scrollTop = 0;

      self.bus.trigger(self.bus.EVENTS.LOCATOR.FOCUS);
    }

    function syncMap(data) {
      self.bus.trigger(self.bus.EVENTS.DEALERS.DATA_LOADED, {
        points: data.points.slice(0, self.maxSlice),
        total: data.total,
      });
    }

    function selectDealer(data) {
      var $dealer = self.tags.dealer[data.index].root;
      var top = $dealer.offsetTop;
      var height = $dealer.offsetHeight;

      if (window.innerWidth >= mapConstants.MOBILE_BREAKPOINT) {
        window.scrollTo(0, top + height - 75);
      }
    }

    self.showMore = showMore;

    self.bus.on(self.bus.EVENTS.DEALERS.SEARCH, reset);
    self.bus.on(self.bus.EVENTS.DEALERS.SET_PREFERRED, setPreferred);
    self.bus.on(self.bus.EVENTS.DEALERS.LIST_UPDATED, syncMap);
    self.bus.on(self.bus.EVENTS.DEALERS.SELECT, selectDealer);
});
